{
  "columns": [],
  "buttons": [],
  "apiDetails": "timesheet-payroll-run-list.json",
  "pageName": "massbatcherrorlist",
  "orderByColumn": ["modifiedDate"],
  "orderBy": ["desc"]
}
